/* eslint-disable no-debugger */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IModal } from 'services/modal';
import { Button } from 'components/parts';
import AddRole from '../components/user-form';
import { FormikProps, FormWrapper } from 'components/form';
import { IFormEditUser, getInitialValues, getValidationSchema } from '../edit/form.config';
import { useSubscription } from 'hooks/use-subscription.hook';
import { addToast } from 'services/toast';
import { editUser } from 'api/user/edit-user.api';
import { useSession } from 'hooks/use-session.hook';
import { myProfile } from 'api/auth/user-profile';
import { isEqual } from 'lodash';

function ModalUserProfile(props: IModal) {
  const {
    modalRef,
    data: { row },
  } = props;
  const [initialValues, setInitialValues] = useState<IFormEditUser>(getInitialValues({}));
  const formikRef = useRef<FormikProps<IFormEditUser>>(null);
  const [reflectData, setReflectData] = useState<IFormEditUser>(null);
  const { t } = useTranslation();
  const subscription = useSubscription();
  const { syncDataWithServer, userInfo } = useSession();

  useEffect(() => {
    const getUserSub = myProfile().subscribe((res) => {
      const initValues = getInitialValues(res.data);

      setInitialValues(initValues);
    });

    subscription.add(getUserSub);
  }, [row.userId, subscription]);

  const onSubmitUserProfile = useCallback(
    (values: IFormEditUser) => {
      addLoading();

      const getUsersSub = editUser(row.userId, window.location.origin, {
        email: values.email,
        empName: values.empName.trim(),
        password: values.password || null,
        pathAvatar: values.pathAvatar || '',
        send_email: true,
        phone: values.phone,
        role: values.role,
        status: values.status,
        username: values.username.trim(),
        oldPassword: values.oldPassword,
        levelId: values.level,
        ownerId: values.ownerId,
      }).subscribe({
        next: () => {
          removeLoading();
          // Update user profile
          syncDataWithServer(true);
          addToast({
            title: t('MS21'),
            description: t('MS21'),
          });
          modalRef.close(true);
        },
        error: () => {
          removeLoading();
        },
      });

      subscription.add(getUsersSub);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [row.userId, modalRef, subscription]
  );

  const onSubmit = () => {
    if (isEqual(initialValues, reflectData)) {
      modalRef.close();
    } else {
      onSubmitUserProfile(reflectData);
    }
  };

  return (
    <FormWrapper<IFormEditUser>
      initialValues={initialValues}
      innerRef={formikRef}
      onSubmit={onSubmit}
      validationSchema={getValidationSchema(_, t)}
      enableReinitialize={true}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <div className='modal-title h4'>{t('header.menu.user_profile')}</div>
        </div>
        <div className='modal-body'>
          <AddRole
            isEdit={false}
            formikRef={formikRef}
            isProfile={true}
            avatar={initialValues.pathAvatar}
            data={userInfo}
            setReflectData={setReflectData}
          />
        </div>
        <div className='modal-footer'>
          <Button type='button' theme='danger' className='h-mr-8' onClick={modalRef.close}>
            {t('common.btn.cancel')}
          </Button>
          <Button type='submit'>{t('common.btn.save')}</Button>
        </div>
      </div>
    </FormWrapper>
  );
}

export default ModalUserProfile;
